/** @format */

import React from 'react';

export const CustomLoadMoreContextual = props => {
    const {onClick, nextPage, pending, handleChangePaginationSize, curPaginationSize} = props;

    const handlePaginationSize = ({target}) => {
        handleChangePaginationSize(target.value);
    };

    if (pending) {
        return (
            <div
                onClick={onClick}
                className="d-flex align-items-center justify-content-center gap-2 color-structure-darker">
                <i className="fa fa-spinner fa-spin" />
                <u>Loading Results...</u>
            </div>
        );
    }

    if (nextPage) {
        return (
            <div className="my-0  mx-auto d-flex align-items-center justify-content-center gap-4">
                <button onClick={onClick} className="color-accent-primary d-block p-0 m-0">
                    <u>Load More Results</u>
                </button>
                <select
                    className="m-0 p-0 color-accent-primary border-0"
                    onChange={handlePaginationSize}
                    value={Number(curPaginationSize) || 5}>
                    {[5, 10, 25, 50].map((size, index) => (
                        <option key={index} value={size}>
                            {size}
                        </option>
                    ))}
                </select>
            </div>
        );
    }

    return <div className="alert alert-info">No more results</div>;
};
